import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvEntry } from "../models/overage";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create overage entry and return same object
 */

export const UpdateOverageEntryAPI = async (params: IOvEntry, osdNumber?: number | string) => {
  try {
    const response = await axios.put(`${getUrl(ApiType.OVERAGE_UPDATE)}/${osdNumber}`, params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.updateOverageEntry, { badRequestOrder: "errorsFirst" });
  }
};
